import { QUESTION_TYPE } from "../../../constants/comman";
import { GenericPreviousExamItem, PreviousExamItem } from "../types/PreviousYearsQuestion";
import _ from 'lodash';
import ContentFormData from "../types/ContentFormData";
export const isQuestionTypeAllowed = (questionTypeCode: number) => {
    
    let questionTypeIsAllowed = true;
  const allowedQuestionTypeCodes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    questionTypeIsAllowed = allowedQuestionTypeCodes.includes(questionTypeCode);
    
    return questionTypeIsAllowed;
  }

export const getQuestionType = (questionTypeCode: string) => {
    const questionType = QUESTION_TYPE[questionTypeCode];
    
    return questionType;
}
export const getGenericPrevExams=(questionId:string,questionPreviousExams:{[key:string]:PreviousExamItem []})=>{
 
  const errorQuestionPrevExams:PreviousExamItem[]=[... questionPreviousExams[questionId]];
  let errorState=false;
  const previousExams:GenericPreviousExamItem []=[];

  questionPreviousExams[questionId].forEach((ele:any,index:any)=>{
     if(_.isEmpty(ele.year) && !_.isEmpty(ele.id)){
      errorQuestionPrevExams[index]={...errorQuestionPrevExams[index],error:true};
      errorState=true; 
    }
     ele.year.forEach((y:string)=>{
            previousExams.push({
              id:ele.id,year:+y,name:ele.name
            });
     });
  });
  const result:[GenericPreviousExamItem[],boolean,PreviousExamItem[]]=[previousExams,errorState,errorQuestionPrevExams]
 return result; 
}
export const  setCustomAnswerKey=(formData:ContentFormData):any=>{
  const sectionsArray=_.get(formData,"data.sections",[]);
  return sectionsArray.forEach((sec:any,index:number)=>{
     sec.subSection.forEach((subSec:any,innerIndx:number)=>{
          if(subSec.quesCodeAllowed===7){  
             subSec.customAnswer=false;  
             const customAns=_.get(subSec,"questions",[]).find((q:any)=>{
                return _.get(q,"qId.content[0].customAnswer",false) ||_.get(q,"content_Id.customAnswer",false) ;
             });
             if(customAns){
              subSec.customAnswer=true;
             }else{
              subSec.customAnswer=false;
             }
          }
          if(index==sectionsArray.length-1 && innerIndx===subSec.length-1){
            return {formData,data:formData.data};
        }   
     });
     
    console.log("Outer");   
  })
}
